<template>
    <tr>
        <td class="images deals-padding">
            <img :src="item.image" alt="">
        </td>
        <td class="deals-padding">
            <div class="top font-normal">{{ item.name | maxLength}}</div>
            <div class="font-normal">{{ item.performer | maxLength }}</div>
            <div class="font-small">lorem CHF {{ item.price }}</div>
        </td>
    </tr>

</template>

<script>
  export default {
    props: ['item']
  }
</script>
